<template>
  <Col :xs="24" :sm="24" :md="12" :lg="8" class="main">
    <slot></slot>
  </Col>
</template>

<script>
    export default {
        name: "cardColumn"
    }
</script>

<style scoped>
  .main {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/core/cardColumn.vue